import React, { useState, useCallback, useLayoutEffect } from "react";
import HttpAction from "modules/utils/HttpAction";

const BoardContext = React.createContext({
  state: { board: {}, commentList: [], pagination: {}, forumList: [], qnaList: [], boardList: []},
  actions: {
    getBoardList: () => {},
    getBoard: () => {},
    createBoard: () => {},
    deleteBoard: () => {},
	saveLike: () => {},
	deleteLike: () => {},
	getCommentList: () => {},
	saveComment: () => {},
	updateComment: () => {},
	deleteComment: () => {},
    updateBoard: () => {}
  },
});

const BoardProvider = ({ children }) => {
    const [board, setBoard] = useState({});
    const [forumList, setForumList] = useState();
    const [qnaList, setQnaList] = useState();
    const [commentList, setCommentList] = useState([]);
    const [boardList, setBoardList] = useState([]); // 마이페이지 boardList

  const getBoard = useCallback((boardId) => {
    HttpAction({
      url: "/member/board",
      method: "get",
      params: {
        boardId: boardId
      }
    }).then((res) => {
      if (res.code === 200) {
        setBoard(res.data);
      } else {
      }
    }).catch(e => {
        // alert(e)
        sessionStorage.removeItem("jwt");
        sessionStorage.removeItem("userId");
        sessionStorage.removeItem("isAdmin");
        sessionStorage.removeItem("loginid");
        let date = new Date(); date.setDate(date.getDate() - 100); document.cookie = "jwt" + "=;Expires=" + date.toUTCString() + ";path=/;domain=" + `${process.env.REACT_APP_DOMAIN_URL}` + ";";
        // document.location.href = "/main"
    });
  }, []);

   const getBoardList = useCallback((params, type) => {

    HttpAction({
      url: "/member/board/list",
      method: "get",
      params: {
          contestId: params && params.contestId,
		  searchTerm: params && params.searchTerm,
		  page: params && params.page,
          categoryName: params && params.categoryName,
          searchRange: params && params.searchRange,
		  records: params && params.records,
		  orderBy: params && params.orderBy,
          type: params && params.type,
          boardType: type && type,
          userId: params && params.userId,
          userName: params && params.userName,
          boardViewCount: params && params.boardViewCount,
          boardId: params && params.boardId,
          commentCount: params && params.commentCount,
      }
    }).then((res) => {
        if (res.code === 200) {

            if(type == "forum") {
                console.log("forum", res.data)
                setForumList(res.data);
            }
            if(type == "qna") {
                setQnaList(res.data);
            }
            if(type === null || type === undefined || type === "") {
                setBoardList( res.data);
            }
      } else {
      }
    }).catch(e => {
        // alert(e)
        sessionStorage.removeItem("jwt");
        sessionStorage.removeItem("userId");
        sessionStorage.removeItem("isAdmin");
        sessionStorage.removeItem("loginid");
        let date = new Date(); date.setDate(date.getDate() - 100); document.cookie = "jwt" + "=;Expires=" + date.toUTCString() + ";path=/;domain=" + `${process.env.REACT_APP_DOMAIN_URL}` + ";";
        // document.location.href = "/main"
    });
  }, []);

  const createBoard = (data) => {
    HttpAction({
        url: "member/board",
        method: "post",
        data: data,
        headers: { "Content-Type": "text/plain" }
    }).then((res) => {
        if (res.code === 200) {
            let url = data.boardType == "forum" ? "viewForum" : "viewQna";
            document.location.href = `/convention/${data.contestId}/${url}`;
          console.log("메뉴 생성에 성공했습니다.");
        } else {
          console.log("메뉴 생성에 실패했습니다.");
        }
      }).catch(e => {
        // alert(e)
        sessionStorage.removeItem("jwt");
        sessionStorage.removeItem("userId");
        sessionStorage.removeItem("isAdmin");
        sessionStorage.removeItem("loginid");
        let date = new Date(); date.setDate(date.getDate() - 100); document.cookie = "jwt" + "=;Expires=" + date.toUTCString() + ";path=/;domain=" + `${process.env.REACT_APP_DOMAIN_URL}` + ";";
        // document.location.href = "/main"
    });
  }

  const deleteBoard = useCallback((boardId) => {
    HttpAction({
      url: "/member/board",
      method: "delete",
      params: {
        boardId: boardId,
      },
    }).then((res) => {
      if (res.code === 200) {

      } else {
      }
    }).catch(e => {
        // alert(e)
        sessionStorage.removeItem("jwt");
        sessionStorage.removeItem("userId");
        sessionStorage.removeItem("isAdmin");
        sessionStorage.removeItem("loginid");
        let date = new Date(); date.setDate(date.getDate() - 100); document.cookie = "jwt" + "=;Expires=" + date.toUTCString() + ";path=/;domain=" + `${process.env.REACT_APP_DOMAIN_URL}` + ";";
        // document.location.href = "/main"
    });
  }, []);

  const updateBoard = (data) => {
    HttpAction({
        url: "/member/board",
        method: "put",
        data: data,
        headers: { "Content-Type": "text/plain" }
    }).then((res) => {
        if (res.code === 200) {
            let url = data.boardType == "forum" ? "viewForum" : "viewQna";
            document.location.href = `/convention/${data.contestId}/${url}`;
            console.log('res', res)
        } else {
        }
      }).catch(e => {
        // alert(e)
        sessionStorage.removeItem("jwt");
        sessionStorage.removeItem("userId");
        sessionStorage.removeItem("isAdmin");
        sessionStorage.removeItem("loginid");
        let date = new Date(); date.setDate(date.getDate() - 100); document.cookie = "jwt" + "=;Expires=" + date.toUTCString() + ";path=/;domain=" + `${process.env.REACT_APP_DOMAIN_URL}` + ";";
        // document.location.href = "/main"
    });
  }

  const saveLike = (boardId, records, order) => {
    HttpAction({
        url: "member/comment/like",
        method: "put",
		params: {
			boardId: boardId
		},
        headers: { "Content-Type": "text/plain" }
    }).then((res) => {
        if (res.code === 200) {
            // getBoard(boardId);
            //
            // let params = {
            //     orderBy: order,
            //     page: 0,
            //     records: records
            // }
            //
            // getBoardList(params, "forum");
        } else {
        }
      }).catch(e => {
        // alert(e)
        sessionStorage.removeItem("jwt");
        sessionStorage.removeItem("userId");
        sessionStorage.removeItem("isAdmin");
        sessionStorage.removeItem("loginid");
        let date = new Date(); date.setDate(date.getDate() - 100); document.cookie = "jwt" + "=;Expires=" + date.toUTCString() + ";path=/;domain=" + `${process.env.REACT_APP_DOMAIN_URL}` + ";";
        // document.location.href = "/main"
    });
  }

  const deleteLike = useCallback((boardId, records, order) => {
    HttpAction({
      url: "/member/comment/like",
      method: "delete",
      params: {
        boardId: boardId,
      },
    }).then((res) => {
      if (res.code === 200) {
		// getBoard(boardId);
        //
        //   let params = {
        //       orderBy: order,
        //       page: 0,
        //       records: records
        //   }
        //
        //   getBoardList(params, "forum");
      } else {
      }
    }).catch(e => {
        // alert(e)
        sessionStorage.removeItem("jwt");
        sessionStorage.removeItem("userId");
        sessionStorage.removeItem("isAdmin");
        sessionStorage.removeItem("loginid");
        let date = new Date(); date.setDate(date.getDate() - 100); document.cookie = "jwt" + "=;Expires=" + date.toUTCString() + ";path=/;domain=" + `${process.env.REACT_APP_DOMAIN_URL}` + ";";
        // document.location.href = "/main"
    });
  }, []);

   //부서 조회
   const getCommentList = useCallback((boardId) => {
    HttpAction({
      url: "/member/comment",
      method: "get",
      params: {
		  boardId: boardId
      }
    }).then((res) => {
      if (res.code === 200) {
        setCommentList(res.data);
      } else {
      }
    }).catch(e => {
        // alert(e)
        sessionStorage.removeItem("jwt");
        sessionStorage.removeItem("userId");
        sessionStorage.removeItem("isAdmin");
        sessionStorage.removeItem("loginid");
        let date = new Date(); date.setDate(date.getDate() - 100); document.cookie = "jwt" + "=;Expires=" + date.toUTCString() + ";path=/;domain=" + `${process.env.REACT_APP_DOMAIN_URL}` + ";";
        // document.location.href = "/main"
    });
  }, []);

  const saveComment = (boardId, content, parentId) => {
    HttpAction({
        url: "member/comment",
        method: "post",
        params: {
			boardId: boardId,
			commentContent: content,
			commentParentId: parentId
		},
        headers: { "Content-Type": "text/plain" }
    }).then((res) => {
        if (res.code === 200) {
            console.log('res', res)
          getCommentList(boardId);
        } else {
        }
      }).catch(e => {
        // alert(e)
        sessionStorage.removeItem("jwt");
        sessionStorage.removeItem("userId");
        sessionStorage.removeItem("isAdmin");
        sessionStorage.removeItem("loginid");
        let date = new Date(); date.setDate(date.getDate() - 100); document.cookie = "jwt" + "=;Expires=" + date.toUTCString() + ";path=/;domain=" + `${process.env.REACT_APP_DOMAIN_URL}` + ";";
        // document.location.href = "/main"
    });
  }

  const updateComment = (commentId, commentContent, boardId) => {
    HttpAction({
        url: "/member/comment",
        method: "put",
        params: {
			commentId: commentId,
			commentContent: commentContent
		},
        headers: { "Content-Type": "text/plain" }
    }).then((res) => {
        if (res.code === 200) {
            console.log('res', res)
          getCommentList(boardId);
        } else {
        }
      }).catch(e => {
        // alert(e)
        sessionStorage.removeItem("jwt");
        sessionStorage.removeItem("userId");
        sessionStorage.removeItem("isAdmin");
        sessionStorage.removeItem("loginid");
        let date = new Date(); date.setDate(date.getDate() - 100); document.cookie = "jwt" + "=;Expires=" + date.toUTCString() + ";path=/;domain=" + `${process.env.REACT_APP_DOMAIN_URL}` + ";";
        // document.location.href = "/main"
    });
  }

  const deleteComment = useCallback((commentId, boardId) => {
    HttpAction({
      url: "/member/comment",
      method: "delete",
      params: {
        commentId: commentId
      },
    }).then((res) => {
      if (res.code === 200) {
		getCommentList(boardId);
      } else {
      }
    }).catch(e => {
        // alert(e)
        sessionStorage.removeItem("jwt");
        sessionStorage.removeItem("userId");
        sessionStorage.removeItem("isAdmin");
        sessionStorage.removeItem("loginid");
        let date = new Date(); date.setDate(date.getDate() - 100); document.cookie = "jwt" + "=;Expires=" + date.toUTCString() + ";path=/;domain=" + `${process.env.REACT_APP_DOMAIN_URL}` + ";";
        // document.location.href = "/main"
    });
  }, []);

  useLayoutEffect(() => {

  }, []);

  const value = {
    state: { board, commentList, forumList, qnaList, boardList },
    actions: { getBoard, getBoardList, createBoard, updateBoard, deleteBoard, saveLike, deleteLike, getCommentList, saveComment,
		updateComment, deleteComment},
  };

  return (
    <BoardContext.Provider value={value}>
      {children}
    </BoardContext.Provider>
  );
};

const { Consumer: BoardConsumer } = BoardContext;

export { BoardProvider, BoardConsumer, BoardContext };

export default BoardContext;
